<template>
  <div class="pagination-simple" v-if="pages>1">
    <button class="pagination-simple__prev" :disabled="modelValue==1" @click="prev()"></button>
    <input class="pagination-simple__field" type="text" :value="modelValue" @change="change($event)">
    <span class="pagination-simple__sparator">z</span>
    <span class="pagination-simple__pages">{{ pages }}</span>
    <button class="pagination-simple__next" :disabled="modelValue == pages" @click="next()"></button>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  components: {},
  props: {
    modelValue: Number,
    pages: Number
  },
  data() {
    return {};
  },
  mounted() {
  },
  computed: {

  },
  emits: ["update:modelValue"],
  watch: {
  },
  methods: {
    prev() {
      if (this.modelValue > 1) {
        this.$emit('update:modelValue', this.modelValue - 1);
      }
    },
    next() {
      if (this.modelValue < this.pages) {
        this.$emit('update:modelValue', this.modelValue + 1);
      }
    },
    change(e) {
      if(!Number.isInteger(e.target.value)) {
        e.target.value = this.modelValue;
      } else {
        this.$emit('update:modelValue', e.target.value)
      }
    }
  }
};
</script>
